module.exports = __webpack_public_path__ + "static/media/38799107_correct-answer-double-02.fe26d4de.mp3";